export default __webpack_public_path__ + "static/media/elevate-lav-4.99cfdbe6.png";